<template>
  <app-content>
      <div class="inner">
        <h1 v-translate>REGEXY</h1>

        <templates :regexType="true" />
      </div>
  </app-content>
</template>

<script>
import Templates from 'components/Show/Common/Templates'
import appTitleMixin from 'mixins/appTitleMixin'

export default {
  name: 'pairing-templates',
  mixins: [appTitleMixin()],
  components: {
    Templates
  },
  computed: {
	  currentTitle() {
		  return [
			  this.$gettext('REGEXY')
		  ]
	  }
  }
}
</script>
